import styled from 'styled-components';

import { CarouselSection as DefaultCarouselSection } from '@xing-com/crate-x4e-carousel-section';
import { mediaSmallOrTiny } from '@xing-com/layout-tokens';
import {
  spaceL,
  spaceS,
  scale110,
  spaceXS,
  xdlColorTextSecondary,
} from '@xing-com/tokens';
import { BodyCopy, Hero } from '@xing-com/typography';

export const CarouselSection = styled(DefaultCarouselSection)`
  padding: 0 ${spaceL};
  max-width: 1520px;
  width: 100%;
  margin: 0 auto;
  & > header {
    margin: ${spaceS};
  }
`;

export const Title = styled(Hero)`
  @media ${mediaSmallOrTiny} {
    font-size: ${scale110};
  }
`;

export const Subtitle = styled(BodyCopy)`
  margin: ${spaceXS} 0 0;
  color: ${xdlColorTextSecondary};
`;
